module.exports = __webpack_public_path__ + "static/media/2BFAFFAE-326D-4CCD-A212-43C98E71AF1F.9efb0692.JPG";